export default __webpack_public_path__ + "static/media/car-g2f299f322_1280.f0288ec3.png";